import tvgConf from "@tvg/conf";
import { get } from "lodash";
import { EnvKey, KeysList } from "./types";

// TVG MEP FE deployment keys are placeholders until created in Amplitude admin.
// Replace "client-REPLACE_WITH_TVG_MEP_FE_*_KEY" with real keys once
// TVG MEP FE Staging and Prod deployments have been created.
const KEYS_LIST: KeysList = {
  qa: {
    tvg: {
      web: "client-jnKlEobFN5VznDxIalCa79Cxx11b03PZ"
    },
    tvg_mep: {
      web: "client-REPLACE_WITH_TVG_MEP_FE_DEV_KEY"
    }
  },
  staging: {
    tvg: {
      web: "client-DybuPFka20yiegOqJwv7R3t4TZBFgvzd"
    },
    tvg_mep: {
      web: "client-REPLACE_WITH_TVG_MEP_FE_STAGING_KEY"
    }
  },
  production: {
    tvg: {
      web: "client-QWuoGcQ3o0cUyK9IvZLiB3BZZ2eSa6QN"
    },
    tvg_mep: {
      web: "client-REPLACE_WITH_TVG_MEP_FE_PROD_KEY"
    }
  }
};

const { environment = "production" } = tvgConf();

const mapEnvironment = (env: string) => {
  if (env === "aws-stg" || env === "staging") return "staging";
  if (env === "aws-prd" || env === "production") return "production";
  if (env === "aws-int" || env === "qa") return "qa";
  return "production";
};

export const ENV_KEYS: EnvKey = get(
  KEYS_LIST,
  mapEnvironment(environment),
  KEYS_LIST.production
);
